import { WorkOrderStatus } from "@model/workOrders/WorkOrder"
import { WorkRequest } from "@model/workRequests/WorkRequest"

export type WorkOrderDeletePermissions = {
    /** Work Order - Delete */
    canDelete: boolean
    /** Close Work Order - Execute */
    canClose: boolean
}

/**
 * Action Item #10455: whether the Delete icon is available for a Work Order.
 *
 * A Closed Work Order no longer has to be put into edit mode first, but deleting one takes the
 * Close Work Order - Execute permission on top of Work Order - Delete. Every other status keeps
 * the original rule: the Delete permission, and not On Hold.
 */
export function isWorkOrderDeletable(
    status: WorkOrderStatus | null | undefined,
    isOnHold: boolean,
    permissions: WorkOrderDeletePermissions
): boolean {
    if (!permissions.canDelete) return false
    if (isOnHold) return false
    if (status === WorkOrderStatus.Closed) return permissions.canClose
    return true
}

/**
 * Action Item #10455: the Service Items deleted alongside a Closed Work Order, which is all of
 * them. Unsaved Service Items carry an id of 0 (see serviceItemFormToWorkRequest) and are dropped
 * so the backend is never asked to delete a row that was never persisted.
 */
export function serviceItemIdsToDeleteWithWorkOrder(workRequests: WorkRequest[]): number[] {
    return workRequests.map((it) => it.id).filter((id) => id > 0)
}
